import React from 'react';
import classnames from 'classnames/bind';
import loadingStyle from './searchLoading.module.scss';
import { getIn18Text } from 'api';
const realStyle = classnames.bind(loadingStyle);
const LoadingIcon = ({ size }) => (React.createElement("span", { className: realStyle('icon'), style: { height: size } },
    React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { opacity: "0.27", d: "M20.8884 11.9998C20.8884 7.09059 16.9087 3.11089 11.9995 3.11089C7.09029 3.11089 3.1106 7.09059 3.1106 11.9998C3.1106 16.909 7.09029 20.8887 11.9995 20.8887C16.9087 20.8887 20.8884 16.909 20.8884 11.9998Z", stroke: "#386EE7", strokeWidth: "3" }),
        React.createElement("path", { d: "M3.11133 12.0005C3.11133 7.09129 7.09102 3.1116 12.0002 3.1116C14.993 3.1116 17.6403 4.59063 19.2512 6.85763", stroke: "#386EE7", strokeWidth: "3", strokeLinecap: "round" }))));
export const SearchLoading = ({ height, text = getIn18Text('SOUSUOZHONG'), size = 24, textStyle = {} }) => (React.createElement("div", { className: realStyle('searchLoading'), style: {
        height: `${height}px`,
    } },
    React.createElement(LoadingIcon, { size: size }),
    React.createElement("p", { className: realStyle('text'), style: textStyle },
        text,
        "...")));
